import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col } from "antd";
import moment from "moment"; // Import moment for date formatting
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useTranslation } from "react-i18next";
import { API_CREATE_COUPEN } from "api/coupen-management";
import { API_LIST_PLAN } from "api/plan-management";
import { useNavigate } from "react-router-dom";
import { API_CREATE_OFFER } from "api/offer-management";

const CreateOffer = () => {
  const [data, setData] = useState();
  const { t } = useTranslation();
  const Navigate = useNavigate();

  const fetchData = async () => {
    try {
      const params = {
        page: "",
        limit: "",
        name: "",
      };
      const newData = await API_LIST_PLAN(params);
      console.log("coupen", newData);
      setData(newData?.plans);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  console.log("data cou", data);
  return (
    <>
      {/* Your existing JSX code remains unchanged */}
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              title: "",
              description: "",
              send_amount: "",
              credit_amount: "",
              valid_till: "",
            }}
            validationSchema={Yup.object({
              title: Yup.string()
                .required("Required")
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              valid_till: Yup.string().required("Required"),
              send_amount: Yup.number().required("Required"),
              credit_amount: Yup.string().required("Required"),
            })}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                // Extract coupon-related values
                const payload = {
                  ...values,
                  valid_till: moment(values.valid_till).unix(),
                };
                const userData = await API_CREATE_OFFER(payload);
                Navigate("/admin/offer-management/offer-tables");

                toast.success(userData?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                {/* Include input fields for all the provided coupon-related fields */}
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Title")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="title"
                        placeholder={t("Title")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="title"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Description")} <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="description"
                        placeholder={t("Description")}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Valid Till Date")}{" "}
                        <span className="text-[red]">*</span>
                      </label>
                      <DatePicker
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        selected={values.valid_till} // Use `selected` prop instead of `value`
                        onChange={(date) => setFieldValue("valid_till", date)}
                        dateFormat="yyyy-MM-dd" // Set your desired date format
                        placeholderText={t("Valid Till Date")}
                        minDate={new Date()}
                      />
                      <ErrorMessage
                        name="valid_till"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Send Amount")}{" "}(User will pay) <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="send_amount"
                        placeholder={t("Send Amount")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="send_amount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={12}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Credit Amount")}{" "}(User will get)
                        <span className="text-[red]">*</span>
                      </label>
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="credit_amount"
                        placeholder={t("Credit Amount")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="credit_amount"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating") + "..." : t("Create Offer")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateOffer;
